import { useEffect, useLayoutEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import { useAuth } from "contexts/auth-context"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { useAuditLogContext } from "contexts/audit-log-context"
import moment from "moment"

export default function Edit() {
  const { id } = useParams()
  const { user } = useAuth()
  const { cache } = useSWRConfig()
  const { queueAuditLog } = useAuditLogContext()
  const { setTransition } = usePage()

  const location = useLocation()
  const navigate = useNavigate()

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [errors, setErrors] = useState({})

  useLayoutEffect(() => {
    setTransition(location.state?.transition)
  }, [location.state?.transition, setTransition])

  // Muat draft yang mau dilanjutkan (GET /stock/transfer/{id}). Hanya DRAFT yang boleh diedit.
  useEffect(() => {
    let mounted = true
    const url = `${process.env.REACT_APP_INVENTORY_API_URL}/stock/transfer/${id}`
    axios
      .get(url)
      .then((res) => {
        const d = res?.data?.data ?? res?.data
        if (!mounted) return
        if (String(d?.status || "").toUpperCase() !== "DRAFT") {
          toast.error("Hanya draft yang bisa dilanjutkan")
          navigate({ pathname: "/stock-transfer" })
          return
        }
        setData(d)
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Gagal memuat draft transfer", {
          ariaProps: { superscript: error?.response?.status },
        })
        navigate({ pathname: "/stock-transfer" })
      })
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (formData) => {
    nProgress.start()
    toast.loading("Menyimpan...", { id: "submit" })

    const url = `${process.env.REACT_APP_INVENTORY_API_URL}/stock/transfer/${id}`

    const formPayload = {
      from_outlet_id: formData.from_outlet_id,
      to_outlet_id: formData.to_outlet_id,
      from_outlet_name: formData.from_outlet_name,
      to_outlet_name: formData.to_outlet_name,
      delivery_order_no: formData.delivery_order_no,
      items: formData.items,
      updated_by: user?.name,
    }

    axios
      .put(url, formPayload)
      .then((response) => {
        queueAuditLog(
          url,
          response.config.method.toUpperCase(),
          "Update Draft Stock Transfer",
          user?.name,
          formPayload,
          null,
          moment().format("YYYY-MM-DD HH:mm:ss"),
          response.status
        )

        cache.clear()
        navigate({ pathname: "/stock-transfer" })
        toast.success(response.data.message || "Draft transfer berhasil diperbarui", { id: "submit" })
      })
      .catch((error) => {
        if (error?.response?.status === 422) {
          setErrors(error.response.data.errors || {})
        }

        toast.error(error?.response?.data?.message || "Gagal", {
          ariaProps: { superscript: error?.response?.status },
          id: "submit",
        })
      })
      .finally(() => {
        nProgress.done()
      })
  }

  if (loading || !data) {
    return <div className="p-10 text-sm text-center text-neutral-500">Memuat draft transfer...</div>
  }

  return <Form data={data} errors={errors} onSubmit={handleSubmit} />
}
